import { NonIndexRouteObject } from 'react-router';

import { PublicRoutes } from './public/public.routes';
import { ProtectedRoutes } from './protected/protected.routes';

export const RootRoutes: NonIndexRouteObject[] = [...PublicRoutes, ...ProtectedRoutes];
